<div class="modal-content">
  <div class="modal-header bg-warning text-white">
    <h4>{{ dialogTitle }}</h4>
  </div>
  <div class="modal-body">
    <p>{{ dialogMessage }}</p>
  </div>
  <div class="modal-footer text-end">
    <button type="button" (click)="cancel()" class="btn btn-secondary btn-sm">
      {{ cancelButtonLabel }}
    </button>
    <button type="button" (click)="accept()" class="btn btn-primary btn-sm">
      {{ acceptButtonLabel }}
    </button>
  </div>
</div>
